import { notification } from 'antd';

export const handleMessageError = (error: any, t: any) => {
    const status = error?.status;
    if (status >= 500) {
        notification.error({
            message: t('response:ERROR'),
            description: t('validateMessage:ERROR_500'),
        });
        return;
    }
    if (status === 403) {
        notification.error({
            message: t('validateMessage:ERROR_403'),
        });
        return;
    }
    const typeMessage = JSON.parse(error?.data?.message) || {};
    notification.error({
        message: t('response:ERROR'),
        description: `${t(`validateMessage:${typeMessage.type}`, {
            name: t(`validateName:${typeMessage.field}`),
        })}`,
    });
};
